import Hero from '../sections/Hero';
import Features from '../sections/Features';
import HowItWorks from '../sections/HowItWorks';
import DailyChallenge from '../sections/DailyChallenge';
import SpinWheel from '../sections/SpinWheel';
import Themes from '../sections/Themes';
import SocialProof from '../sections/SocialProof';
import DownloadCTA from '../sections/DownloadCTA';
import Footer from '../sections/Footer';

export default function HomePage() {
  return (
    <>
      <Hero />
      <Features />
      <HowItWorks />
      <DailyChallenge />
      <SpinWheel />
      <Themes />
      <SocialProof />
      <DownloadCTA />
      <Footer />
    </>
  );
}
